import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import { checkInitialLoginForExistingCookie } from 'routes/AppContainer/actions';
import { Clickable } from 'components/Clickable/Clickable';
import { AltaLogo } from 'new-components/svgs/AltaLogo';

import './LogoAndLabel.scss';

const openpathConfig = require('openpathConfig');

const styles = {
  environment: {
    fontSize: '16px',
    marginLeft: 22,
    height: 22,
    pointerEvents: 'none',
  },
  envText: {
    padding: '0 22px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
};

export const LogoAndLabel = ({ isMobile }) => {
  const dispatch = useDispatch();

  const getColorForEnvSuffix = (suffix) => {
    if (suffix.includes('sandbox')) {
      return 'var(--colorSuccess)';
    }

    return 'var(--colorText)';
  };

  const handleLogoClick = () => {
    dispatch(checkInitialLoginForExistingCookie());
  };

  return (
    <div className="op-logo-and-label">
      <Clickable className="op-logo-and-label__logo" onClick={handleLogoClick}>
        <AltaLogo />
      </Clickable>

      {!isMobile &&
        openpathConfig.ENV_SUFFIX &&
        openpathConfig.ENV_SUFFIX.trim() !== '' && (
          <div
            className="op-font-weight-500"
            style={{
              ...styles.environment,
              color: getColorForEnvSuffix(openpathConfig.ENV_SUFFIX),
            }}
          >
            <div style={styles.envText}>ENV: {openpathConfig.ENV_SUFFIX}</div>
          </div>
        )}
    </div>
  );
};

LogoAndLabel.propTypes = {
  isMobile: PropTypes.bool,
};
